import axios from "axios"
import { useState, useEffect, useRef } from "react";
/* import { NavLink, useNavigate } from "react-router-dom"; */
import RegisterStyle from './Register.module.css'
import Papa from "papaparse";
import Select from 'react-select';

export default function Register({ registerData, setRegisterData }) {

    /* const navigate = useNavigate() */
    const [cities, setCities] = useState([]);
    const [streets, setStreets] = useState([]);
    const [streetsSAs, setStreetSAs] = useState([]);
    const [data, setData] = useState(() => registerData || { currentUnits: '', projectStat: '', projectDescription: '', projectType: "", proposeUnits: '', reachUnits: '', longTermUnits: '', address: { city: "", cityCode: "", street: "", streetCode: "", number: "" , eshkol: ""}, isPeriphery: false });
    //const [address, setAddress] = useState({ city: "", cityCode: null, street: "", streetCode: null, number: "" , eshkol: null});

    useEffect(() => {
          fetch("/data/cities.csv")
            .then((res) => res.text())
            .then((text) => {
                const parsed = Papa.parse(text, { header: true });
                const cityList = parsed.data
                    .map(row => ({
                       label: row.locality?.trim(),
                       value: row.code?.trim()
                    }))
                    .filter(city => city.label && city.value)
                    .sort((a, b) => a.label.localeCompare(b.label, 'he'));
                //const cityList = parsed.data.map((row) => row[1]).filter(Boolean);
                setCities(cityList);
        })
        .catch((err) => console.error("Failed to load cities:", err));
    }, []);

    useEffect(() => {
        if (!data.address.cityCode) {
            setStreets([]);
            return;
        }
        fetch("/data/streets.csv")
            .then((res) => res.text())
            .then((text) => {
                const parsed = Papa.parse(text, { header: true });
                const streetList = parsed.data
                    .filter(row => row.locality_code?.trim() === data.address.cityCode)
                    .map(row => ({
                       label: row.street?.trim(),
                       value: row.id?.trim()
                    }))
                    .filter(street => street.label && street.value)
                    .sort((a, b) => a.label.localeCompare(b.label, 'he'));
                setStreets(streetList);
        })
        .catch((err) => console.error("Failed to load streets:", err));
        }, [data.address.cityCode]);
    
    useEffect(() => {
        if (!data.address.cityCode) {
            setStreets([]);
            return;
        }
        fetch("/data/streets_SAs.csv")
            .then((res) => res.text())
            .then((text) => {
                const parsed = Papa.parse(text, { header: true });
                const streetsSAList = parsed.data
                    .filter(row => row.street_id?.trim() === data.address.streetCode)
                    .map(row => {
                        const from = parseInt(row.from_number?.trim(), 10);
                        const toRaw = row.to_number?.trim();
                        const to = toRaw === "+" ? null : parseInt(toRaw, 10);
                        const side = row.street_side?.trim();
                        const eshkol = row.SA_eshkol?.trim();

                        return {
                            from: isNaN(from) ? null : from,
                            to: isNaN(to) ? null : to,
                            side: side || null,       // "1", "2", or null
                            eshkol: eshkol || null,
                        };
                        })
                        .filter(row => row.eshkol !== null);
                setStreetSAs(streetsSAList);
        })
            .catch((err) => console.error("Failed to load streetsSAs:", err));
        }, [data.address.streetCode]);

    /* useEffect(() => {
        console.log("Updated address:", address);
    }, [address]); */

    // sessionStorage.ServoryID !== '' ||
    
    //useEffect(() => {
    //    setData(prev => ({ ...prev, address }));
    //}, [address]);

    useEffect(() => {
        setRegisterData(data);
    }, [data]);

 
    
        const handleChange = (event) => {
        let name = event.target.name
        let value = event.target.value
        setData(prev => ({ ...prev, [name]: value }))
    }

    const handleAddress = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        //setAddress({ ...data.address, [name]: value });
        setData({ ...data, "address": data.address });
        console.log(event.target);
    }

    const handleCityChange = (selectedOption) => {
        if (selectedOption) {
            const newAddress = {...data.address, city: selectedOption.label, cityCode: selectedOption.value, street: "", streetCode: null, number: "", eshkol: null};
            //setAddress(newAddress);
            setData({...data, address: newAddress});
        } else {
            // Clear selection
            //setAddress(prev => ({ ...prev, city: "", cityCode: null, street: "", streetCode: null, number: "", eshkol: null }));
            setData(prev => ({ ...prev, address: { ...prev.address, city: "", cityCode: null, street: "", streetCode: null, number: "", eshkol: null} }));
        }
    };

    const handleStreetChange = (selectedOption) => {
        if (selectedOption) {
            const newAddress = {...data.address, street: selectedOption.label, streetCode: selectedOption.value, number: "", eshkol: null}
            setData({...data, address: newAddress});
        } else {
            // Clear selection
            setData(prev => ({ ...prev, address: { ...prev.address, street: "", streetCode: "", number: "", eshkol: null} }));
        }
    };

    const handleStreetNum = (event) => {
        //fetch eshkol
        const value = event.target.value?.trim();
        const num = parseInt(value, 10);

        if (isNaN(num)) {
            //setAddress(prev => ({ ...prev, number: value, eshkol: null }));
            setData(prev => ({ ...prev, address: { ...prev.address, number: value, eshkol: null } }));
            return;
        }

        const isEven = num % 2 === 0;

        const matchedSA = streetsSAs.find(row => {
            const matchesSide =
            row.side === "1" ? !isEven :
            row.side === "2" ? isEven :
            true; // match if side is null

            const inRange = row.from === null || row.to === null || (num >= row.from && num <= row.to);
            return matchesSide && inRange;
        });

        const eshkol = matchedSA?.eshkol || null;
        const isPeriphery = eshkol !== null && Number(eshkol) < 7;

        //setAddress({ ...address, number: value, eshkol: eshkol});
        //setData({ ...data, "address": address });

        //updated code to avoid passing stale data:
        const updatedAddress = { ...data.address, number: value, eshkol: eshkol };
        //setAddress(updatedAddress);
        setData(prev => ({ ...prev, address: updatedAddress, isPeriphery }));
        console.log(eshkol, data.address);
    }

    const projectTypeOptions = [
        { value: "cvl6tpa23akg00feene0", label: "פינוי - בינוי" },
        { value: "cvl6tpa23akg00feeneg", label: "תמ\"א 38" }
    ];

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#355279' : '#355279', // Selected: white, Otherwise: dark grey
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#355279', // Color for selected value in the input
        }),
        control: (provided, state) => ({
            ...provided,
            border: 'none',             // Remove border
            borderRadius: '12rem',    // Match your form style (adjust as needed)
            boxShadow: 'none',          // Remove focus ring
            backgroundColor: 'transparent', // Optional: inherit background
            minHeight: 'unset',         // Optional: reduces default height
        }),
        indicatorSeparator: () => ({
            display: 'none'             // Optional: removes the vertical separator line
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '4px'              // Optional: compact arrow area
        }),
    };

    return (<>
        {/* <form onSubmit={handleSubmit} className={RegisterStyle.formRegister}> */}
            {/* <h2>הירשם או <NavLink to={'/login'}> התחבר</NavLink> </h2> */}
            {/* <h2></h2> */}
            {/* <label className={RegisterStyle.inputBox}>

                <input type="text" name="companyName" value={data.companyName} placeholder="שם החברה" onChange={handleChange} required />
            </label>
            <label className={RegisterStyle.inputBox}>

                <input type="email" name="email" value={data.email} placeholder="Email" onChange={handleChange} required />
            </label> */}
        <form className={RegisterStyle.formRegister}>
            <label className={RegisterStyle.inputBox}>
                {/* <input type="text" value="cityFilter" placeholder="בחר עיר..." onChange={filterCities}  */}
                <Select
                    options={cities}
                    value={data.address?.cityCode ? cities.find(c => c.value === data.address.cityCode) : null}
                    onChange={handleCityChange}
                    placeholder="עיר"
                    isClearable
                    classNamePrefix="react-select"
                    noOptionsMessage={() => "לא נמצאו תוצאות"}
                    styles={customStyles}
                    className={RegisterStyle.selectFullWidth}
                />
            </label>
            <label className={RegisterStyle.inputBox}>
                <Select
                    options={streets}
                    value={streets.find(s => s.value === data.address?.streetCode) || null}
                    onChange={handleStreetChange}
                    placeholder="רחוב"
                    isClearable
                    classNamePrefix="react-select"
                    noOptionsMessage={() => "לא נמצאו תוצאות"}
                    styles={customStyles}
                    className={RegisterStyle.selectFullWidth}
                />
            </label>
            <label className={RegisterStyle.inputBox}>
                <input 
                type="number" 
                value={data.address?.number} 
                name="number" 
                onChange={handleStreetNum} 
                placeholder="מספר בית"
                step="1"
                pattern="\d*"
                min="0"
                onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                    }}}
                />            </label>
                <label className={RegisterStyle.inputBox}>
                <Select
                    options={projectTypeOptions}
                    value={projectTypeOptions.find(opt => opt.value === data.projectType) || null}
                    onChange={(selected) =>
                        setData(prev => ({ ...prev, projectType: selected ? selected.value : "" }))
                    }
                    placeholder="סוג הפרויקט"
                    classNamePrefix="react-select"
                    noOptionsMessage={() => "לא נמצאו תוצאות"}
                    styles={customStyles}
                    className={RegisterStyle.selectFullWidth}
                />
                </label>
{/*             <label className={RegisterStyle.optionBox}>
                סוג פרוייקט:
                <select name="projectType" value={data.projectType} style={{ marginRight: "1.5rem" }} onChange={handleChange} required>
                    <option value="c8ggpka23aks73b4lhcg">פינוי - בינוי</option>
                    <option value="c8ggpka23aks73b4lhd0">תמ"א 38</option>
                </select>
            </label> */}
            <label className={RegisterStyle.inputBox}>

                <input type="number" value={data.currentUnits} name="currentUnits" min='0' placeholder="יחידות דיור במצב קיים" onChange={handleChange} required />
            </label>
            <label className={RegisterStyle.inputBox}>

                <input type="number" value={data.proposeUnits} name="proposeUnits" min='0' placeholder="יחידות דיור במצב המוצע" onChange={handleChange} required />
            </label>
            <label className={RegisterStyle.inputBox}>

                <input type="number" value={data.reachUnits} name="reachUnits" min='0' placeholder="יחידות דיור בהישג יד במצב המוצע" onChange={handleChange} required />
            </label>
            <label className={RegisterStyle.inputBox}>

                <input type="number" value={data.longTermUnits} name="longTermUnits" min='0' placeholder="יחידות דיור לשכירות ארוכת טווח במצב המוצע" onChange={handleChange} required />
            </label>
            <label className={RegisterStyle.inputBox}>

                <input type="text" value={data.projectStat} name="projectStat" placeholder="השלב בו מצוי הפרויקט" onChange={handleChange} />
            </label>
            <label className={RegisterStyle.textareaBox}>

                <textarea rows="4" value={data.projectDescription} name="projectDescription" placeholder="תיאור הפרויקט" onChange={handleChange} />
            </label>

            {/* <input className={RegisterStyle.submit} type="submit" value="הירשם" /> */}
        </form>
        {/* <div style={{ fontWeight: 'bold', fontSize: '1.3rem', textAlign: 'center' }} ref={submitInfo}></div> */}
    </>
    )

}